import { CompatibilityDetails } from "./Compatibility.type";

export const getUsersByCompatibility = (
  users: CompatibilityDetails[],
  filterFn: (c: CompatibilityDetails) => boolean
) => users.filter(filterFn);
